import { UserNavigationComponent } from 'src/app/partials/navigation/user-navigation/user-navigation.component';
import { DashboardService } from 'src/app/services/dashboard.service';
import { UserService } from 'src/app/services/user.service';
import { NgxPaginationModule } from 'ngx-pagination';
import { OrganisationService } from 'src/app/services/organisation.service';
import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { first, concatMap, debounceTime, distinctUntilChanged} from 'rxjs/operators';
import { AdminService } from './../../../services/admin.service';
import { ChallengeUsers } from 'src/app/pages/admin/challenge-report/challenge-interface';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { map, tap } from 'rxjs/operators';
import * as moment from 'moment-timezone';
import { Chart } from 'chart.js';
import * as jquery from 'jquery';
import {fromEvent} from "rxjs";

@Component({
  selector: 'app-manager-dashboard',
  templateUrl: './manager-dashboard.component.html',
  styleUrls: ['./manager-dashboard.component.scss'],
  providers: [DatePipe]
})
export class ManagerDashboardComponent implements OnInit, AfterViewInit {

  @ViewChild(UserNavigationComponent) userNavigation;
  // @ViewChild('searchEnterprise') searchEnterprise: ElementRef;
  @ViewChild('searchNameOrEmail') searchNameOrEmail: ElementRef;
  @ViewChild('searchVoucher') searchVoucher: ElementRef;

  p: any;
  users = [];
  search_name: string;
  modalText = 'Loading...';
  error = false;

  currentPage: number;
  lastPage: number;
  pageLinks: number[] = [];
  searchValue = '';
  processingSearch = 0;

  loginData = [];
  loginLabels = [];
  videoData = [];
  videoLabels = [];
  pointsData = [];
  pointsLabels = [];

  myDate = new Date();
  today: string;
  todayYmd: string;

  hoveredDate: NgbDate | null = null;
  fromDate: NgbDate | null;
  toDate: NgbDate | null;
  fromUnixTimestamp = '';
  toUnixTimestamp = '';
  dpFromDate: NgbDate;
  dpToDate: NgbDate;
  organisation = '';
  organisation_id = '';
  name_or_email = '';
  voucher = '0';
  usersTotal = 0;

  challengeUsers: ChallengeUsers = {
    users_completed: 0,
    total_users: 0,
    users_completed_percentage: 0,
    improved_question_1: 0,
    improved_question_2: 0,
    improved_question_3: 0,
    users: []
  }
  vouchers = [];
  orgDetails = {
    admins: [],
    vouchers: [],
    total_users: 0,
    total_users_percentage: 0,
    trainer_users_percentage: 0,
    challenge_user_7_day: {
      users_completed_percentage: 0,
      users_completed:0,
      improved_question_1: 0,
      improved_question_2: 0,
      improved_question_3: 0,
    },
    organisation: {
      name: '',
      points: 0
    }
  };

  users_completed = 0;
  sleep_improvement = 0;
  calm_improvement = 0;
  energy_improvement = 0;

  constructor(
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private pageTitleService: Title,
    private userService: UserService,
    private dashboardService: DashboardService,
    private organisationService: OrganisationService,
    private adminService: AdminService,
  ) { }

  ngOnInit(): void {
    this.pageTitleService.setTitle(this.route.snapshot.data.title || 'Billing History');
    this.today = this.datePipe.transform(this.myDate, 'd MMM yyyy');
    this.todayYmd = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
    this.loadData();
    this.loadChallengeUsers();
    this.voucherList();
  }

  ngAfterViewInit(): void {
    this.filterNameOrEmail();
  }

  lastWeek() {
    this.myDate.setDate(this.myDate.getDate() - 7);
    this.today = this.datePipe.transform(this.myDate, 'd MMM yyyy');
    this.todayYmd = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
    this.loginData = [];
    this.loginLabels = [];
    this.videoData = [];
    this.videoLabels = [];
    this.pointsData = [];
    this.pointsLabels = [];
    this.loadData();
  }

  nextWeek() {
    this.myDate.setDate(this.myDate.getDate() + 7);
    this.today = this.datePipe.transform(this.myDate, 'd MMM yyyy');
    this.todayYmd = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
    this.loginData = [];
    this.loginLabels = [];
    this.videoData = [];
    this.videoLabels = [];
    this.pointsData = [];
    this.pointsLabels = [];
    this.loadData();
  }

  loadData() {

    // Show progress modal
    this.showProgressModal();

    this.userService.getProfile()
      .pipe(

        // Get User Details
        map(user => user.data.user),
        tap(user => {
          this.userNavigation.user = user;
        }),

        // Get Organisation Details
        concatMap(() => this.userService.getManagerDetails()),
        map(orgDetails => orgDetails.data),
        tap(orgDetails => {
          //console.log('orgDetails', orgDetails);
          this.orgDetails = orgDetails;
          this.organisation_id = orgDetails.organisation.id;
          this.users_completed = orgDetails.challenge_user_7_day.users_completed;
          this.sleep_improvement = orgDetails.challenge_user_7_day.improved_question_1;
          this.calm_improvement = orgDetails.challenge_user_7_day.improved_question_2;
          this.energy_improvement = orgDetails.challenge_user_7_day.improved_question_3;
        }),
        
        // Get Users
        concatMap(() => this.userService.userlist(1, '')),
        map(userData => userData.data),
        tap(userData => {
          this.users = userData.users;
          const totalRecords = userData.pagination?.total_records;
          this.lastPage = userData.pagination?.last_page;
          this.pageLinks = [];
          if (totalRecords > 0) {
            this.currentPage = userData.pagination?.current_page;
            for (let index = 1; index <= this.lastPage; index++) {
              this.pageLinks.push(index);
            }
          }
        }),

      )
      .subscribe(
        response => {
          if (response) {
            setTimeout(() => {
              // hide progress modal
              this.hideProgressModal();
              this.search();
            }, 500);
          }
        },
        error => {
          // hide progress modal
          this.hideProgressModal();
          this.error = true;
        }
      );
  }

  loadChart(dataname = '', canvas_id = '', label = '', labels, data) {
    this[dataname] = new Chart(canvas_id, {
      type: 'line',
      data: {
        labels: labels,
        datasets: [{
          label: label,
          data: data,
          backgroundColor: ['rgba(1, 107, 132, 0.1)'],
          borderColor: ['rgba(1, 107, 132, 1)'],
          borderWidth: 2
        }]
      },
      options: {
        maintainAspectRatio: false,
        spanGaps: false,
        elements: {
          line: {
            tension: 0.000001
          }
        },
        plugins: {
          filler: {
            propagate: false
          }
        },
        legend: {
          display: false,
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              stepSize: 1
            }
          }]
        }
      }
    });
  }

  search() {
    const searchBox = document.getElementById('searchUserInput');
    if (searchBox) {
      const keyup$ = fromEvent(searchBox, 'keyup');
      keyup$
        .pipe(
          map((event: any) => {
            this.searchValue = event.target.value;
            return event.target.value;
          }),
          debounceTime(1000),
          distinctUntilChanged()
        )
        .subscribe((text: string) => {
          this.modalText = (text !== '') ? 'Searching...' : 'Loading...';
          this.loadUsers(1, this.searchValue);
        });
    }
  }

  loadUsers(pageNumber: number = 1, searchValue: string = '') {
    if (this.processingSearch == 0) {

      // Show progress modal
      this.showProgressModal();

      this.processingSearch = 1;
      this.userService.userlist(pageNumber, searchValue)
        .pipe(first())
        .subscribe(data => {
          this.users = data.data.users;
          const totalRecords = data.data.pagination?.total_records;
          this.lastPage = data.data.pagination?.last_page;
          this.pageLinks = [];
          if (totalRecords > 0) {
            this.currentPage = data.data.pagination?.current_page;
            for (let index = 1; index <= this.lastPage; index++) {
              this.pageLinks.push(index);
            }
          }
          this.processingSearch = 0;

          setTimeout(() => {
            // hide progress modal
            this.hideProgressModal();
          }, 500);

          setTimeout(() => {
            this.search();
          }, 0);
        });
     }
  }

  filterNameOrEmail() {
    fromEvent(this.searchNameOrEmail.nativeElement, 'keyup')
      .pipe(
        map((event: any) => {
          this.name_or_email = event.target.value;
          return event.target.value;
        }),
        debounceTime(2000),
        distinctUntilChanged()
      )
      .subscribe((text: string) => {
        this.modalText = (text !== '') ? 'Searching...' : 'Loading...';
        this.filter7dayChallenge(1, this.organisation_id, this.name_or_email, this.voucher, this.fromUnixTimestamp, this.toUnixTimestamp);
      });
  }

  filterVoucher() {
    fromEvent(this.searchVoucher.nativeElement, 'keyup')
      .pipe(
        map((event: any) => {
          this.voucher = event.target.value;
          return event.target.value;
        }),
        debounceTime(2000),
        distinctUntilChanged()
      )
      .subscribe((text: string) => {
        this.modalText = (text !== '') ? 'Searching...' : 'Loading...';
        this.loadChallengeUsers(1, this.organisation, this.name_or_email, text, this.fromUnixTimestamp, this.toUnixTimestamp)
      });
  }

  onDateFromSelection(fromDate: NgbDate) {
    this.fromDate = fromDate;
    const fromDateF = this.fromDate.day + '/' + this.fromDate.month + '/' + this.fromDate.year;
    if (this.toDate) {
      if (this.fromDate.after(this.toDate)) {
        jquery('#dateInputFrom').val(fromDateF);
        this.fromDate = fromDate;

        this.toDate = null;
        this.dpToDate = null;
      } else {
        jquery('#dateInputFrom').val(fromDateF);
      }
    }
    this.onDateSelection();
  }

  onDateToSelection(toDate: NgbDate) {
    this.toDate = toDate;
    const toDateF = this.toDate.day + '/' + this.toDate.month + '/' + this.toDate.year;
    if (this.fromDate) {
      if (this.toDate.before(this.fromDate)) {
        jquery('#dateInputFrom').val(toDateF);
        this.fromDate = toDate;

        jquery('#dateInputTo').val('');
        this.toDate = null;
        this.dpToDate = null;
      } else {
        jquery('#dateInputTo').val(toDateF);
      }
    }
    this.onDateSelection();
  }

  onDateSelection() {
    // Get the Unix Timestamp for DateFrom and DateTo
    if (this.fromDate && this.toDate) {

      // Handles From Date Conversion to timestamp
      const fromMonth = (this.fromDate.month < 10) ? '0' + this.fromDate.month : this.fromDate.month;
      const fromDay = (this.fromDate.day < 10) ? '0' + this.fromDate.day : this.fromDate.day;
      const fromYear = this.fromDate.year;
      const fromDate = fromYear + '-' + fromMonth + '-' + fromDay + ' 00:00:00';
      this.fromUnixTimestamp = moment.tz(fromDate.toString(), 'YYYY-MM-DD HH:mm:ss', moment.tz.guess()).format('X');

      // Handles To Date Conversion to timestamp
      const toMonth = (this.toDate.month < 10) ? '0' + this.toDate.month : this.toDate.month;
      const toDay = (this.toDate.day < 10) ? '0' + this.toDate.day : this.toDate.day;
      const toYear = this.toDate.year;
      const toDate = toYear + '-' + toMonth + '-' + toDay + ' 23:59:59';
      this.toUnixTimestamp = moment.tz(toDate.toString(), 'YYYY-MM-DD HH:mm:ss', moment.tz.guess()).format('X');

    }

    if (this.fromUnixTimestamp !== '' && this.toUnixTimestamp !== '') {
      this.modalText = 'Searching...';
      this.filter7dayChallenge(1, this.organisation_id, this.name_or_email, this.voucher, this.fromUnixTimestamp, this.toUnixTimestamp);
    }
  }

  clearDateFrom() {
    if (this.fromDate) {
      jquery('#dateInputFrom').val('');
      this.fromDate = null;
      this.fromUnixTimestamp = '';
      this.dpFromDate = null;
      this.filter7dayChallenge(1, this.organisation_id, this.name_or_email, this.voucher, this.fromUnixTimestamp, this.toUnixTimestamp);
    }
  }

  clearDateTo() {
    if (this.toDate) {
      jquery('#dateInputTo').val('');
      this.toDate = null;
      this.toUnixTimestamp = '';
      this.dpToDate = null;
      this.filter7dayChallenge(1, this.organisation_id, this.name_or_email, this.voucher, this.fromUnixTimestamp, this.toUnixTimestamp);
    }
  }

  voucherList() {
    this.organisationService.allVoucher(this.organisation)
    .subscribe(
      data => {
        let vouchers = [];
        for (let key in data.data.vouchers) {
          vouchers.push({key: data.data.vouchers[key]['id'], value: data.data.vouchers[key]['code']});
        }

        vouchers.sort(this.dynamicSort("value"));

        vouchers = [{key: '0', value: 'Select Voucher'}, ...vouchers];

        this.vouchers = vouchers;

        // hide progress modal
        this.hideProgressModal();
      },
      error => {
        // hide progress modal
        this.hideProgressModal();
      }
    );
  }

  changeVoucher() {
    this.filter7dayChallenge(1, this.organisation_id, this.name_or_email, this.voucher, this.fromUnixTimestamp, this.toUnixTimestamp);
  }

  dynamicSort(property) {
    var sortOrder = 1;

    if(property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }

    return function (a,b) {
        if(sortOrder == -1){
            return b[property].localeCompare(a[property]);
        }else{
            return a[property].localeCompare(b[property]);
        }        
    }
  }

  loadChallengeUsers(pageNumber: number = 1, organisation: string = '', name_or_email: string = '', voucher: string = '', dateFrom: string = '', dateTo: string = '') {
    // Show progress modal
    this.showProgressModal();
    this.userService.challengeReportList(pageNumber, organisation, name_or_email, voucher, dateFrom, dateTo)
      .pipe(
        map(userData => userData.data),
        tap(userData => {
            //console.log('userData', userData);
            this.challengeUsers = userData;

            const totalRecords = userData.pagination?.total_records;
            this.lastPage = userData.pagination?.last_page;
            this.pageLinks = [];
            if (totalRecords > 0) {
              this.currentPage = userData.pagination?.current_page;
              for (let index = 1; index <= this.lastPage; index++) {
                this.pageLinks.push(index);
              }
            }

            this.usersTotal = totalRecords;
        }))
      .subscribe(
        response => {
          if (response !== undefined) {
            setTimeout(() => {
              // hide progress modal
              this.hideProgressModal();
            }, 500);
          }
        },
        error => {
          // hide progress modal
          this.hideProgressModal();
        }
      );
  }

  private showProgressModal() {
    jquery('#loaderSpin').show();
  }

  private hideProgressModal() {
    jquery('#loaderSpin').hide();
  }

  paginate(pageNumber: number) {
    if (pageNumber > 0) {
      this.loadChallengeUsers(pageNumber);
    }
  }

  filter7dayChallenge(pageNumber: number = 1, organisation: string = '', name_or_email: string = '', voucher: string = '', dateFrom: string = '', dateTo: string = '') {
    // Show progress modal
    this.showProgressModal();
    this.adminService.challengeReportList(pageNumber, organisation, name_or_email, voucher, dateFrom, dateTo)
      .pipe(
        map(userData => userData.data),
        tap(userData => {
            //console.log('userData', userData);
            this.users_completed = userData.users_completed;
            this.sleep_improvement = userData.improved_question_1;
            this.calm_improvement = userData.improved_question_2;
            this.energy_improvement = userData.improved_question_3;
        }))
      .subscribe(
        response => {
          if (response !== undefined) {
            setTimeout(() => {
              // hide progress modal
              this.hideProgressModal();
            }, 500);
          }
        },
        error => {
          // hide progress modal
          this.hideProgressModal();
        }
      );
  }

}
